<template>
    <v-content>
        <v-breadcrumbs :items="breadcrumbsItems" large></v-breadcrumbs>

        <v-snackbar :color="callbackResponse.color" :timeout="callbackResponse.timeout" top
                    v-model="callbackResponse.snackbar">
            {{callbackResponse.message}}
            <v-btn @click="callbackResponse.snackbar = false" dark text>Close</v-btn>
        </v-snackbar>

        <div>
            <v-row>
                <v-col cols="12" sm="11">
                    <v-autocomplete
                            :error-messages="yearErrors"
                            :items="yearList"
                            @input="setValueYear(searchFormData.year)"
                            item-text="id"
                            item-value="value"
                           :label="$t('selectyear')"
                            required dense outlined
                            v-model="searchFormData.year">
                    </v-autocomplete>
                </v-col>
                <v-col>
                    <v-btn @click="searchSubmit" color="blue" dark>{{$t('search')}}</v-btn>
                </v-col>
            </v-row>

        </div>

        <div v-if="search">

            <div class="tbl-btn">
                <v-row>
                    <v-col class="btn-download" cols="2">
                        <v-btn @click="downloadData" color="green" dark>{{$t('download_sample')}}</v-btn>
                    </v-col>
                    <v-col class="btn-download" cols="2">
                        <v-btn @click="downloadTotalData('tblDirectUploadData','Total-Meat-Expenses')" color="green" dark>{{$t('download_file')}}</v-btn>
                    </v-col>
                    <v-col cols="4" offset-sm="6">
                        <v-row>
                            <v-file-input label="upload file" show-size v-model="formData.excel"></v-file-input>
                            <v-btn @click="uploadData" color="blue" dark>{{$t('upload')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-row>
            </div>

            <div id="tblDirectUploadData">

                <h2 style="text-align:center">खसी वोका तथा च्याङ्ग्रा कारोवारको विवरण</h2>

                <br>
                <table border="1">
                    <thead>
                    <tr>
                        <th rowspan="3">क्र सं</th>
                        <th rowspan="3">खसी वोका तथा च्याङ्ग्राको विवरण</th>
                        <th colspan="6">आ व {{setYearValue}}</th>
                        <th colspan="3">आ व {{setYearValue}}</th>
                    </tr>
                    <tr>
                        <th colspan="3">खरिद लक्ष्य</th>
                        <th colspan="3">अनुमानित प्रगति</th>
                        <th colspan="3">प्रस्तावित</th>
                    </tr>
                    <tr>
                        <th>संख्या</th>
                        <th>दर</th>
                        <th>रकम</th>
                        <th>संख्या</th>
                        <th>दर</th>
                        <th>रकम</th>
                        <th>संख्या</th>
                        <th>दर</th>
                        <th>रकम</th>
                    </tr>
                    </thead>

                    <tbody>
                        <template v-for="(table,indexT) in tableData.list">

                            <tr :key="'I'+indexT" class="total-header">
                                <th></th>
                                <th>{{table.type}}</th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                            </tr>

                            <tr :key="indexT+innerData+'A'" v-for="(innerData,index) in  table.list">
                                <th>{{++index}}</th>
                                <th>{{innerData.name}}</th>
                                <th>{{innerData.targetQuantity}}</th>
                                <th>{{innerData.targetPerAmount}}</th>
                                <th>{{innerData.targetAmount}}</th>
                                <th>{{innerData.estimatedQuantity}}</th>
                                <th>{{innerData.estimatedPerAmount}}</th>
                                <th>{{innerData.estimatedAmount}}</th>
                                <th>{{innerData.proposedQuantity}}</th>
                                <th>{{innerData.proposedPerAmount}}</th>
                                <th>{{innerData.proposedAmount}}</th>

                            </tr>

                            <tr :key="'I'+indexT" class="total" v-if="table.totals">
                                <th colspan="2"><b>जम्मा</b></th>
                                <th><b>{{table.totals.totalTargetQuantity}}</b></th>
                                <th><b>{{table.totals.totalTargetPerAmount}}</b></th>
                                <th><b>{{table.totals.totalTargetAmount}}</b></th>
                                <th><b>{{table.totals.totalEstimatedQuantity}}</b></th>
                                <th><b>{{table.totals.totalEstimatedPerAmount}}</b></th>
                                <th><b>{{table.totals.totalEstimatedAmount}}</b></th>
                                <th><b>{{table.totals.totalProposedQuantity}}</b></th>
                                <th><b>{{table.totals.totalProposedPerAmount}}</b></th>
                                <th><b>{{table.totals.totalProposedAmount}}</b></th>
                            </tr>
                        </template>
                        <tr class="total" v-if="tableData.profitTotals || tableData.expensesTotals">
                            <th colspan="2"><b>
                        नाफा/नोक्सान
                        </b></th>
                            <th><b>{{tableData.profitTotals.totalTargetQuantity-tableData.expensesTotals.totalTargetQuantity}}</b></th>
                            <th><b>{{tableData.profitTotals.totalTargetPerAmount-tableData.expensesTotals.totalTargetPerAmount}}</b></th>
                            <th><b>{{tableData.profitTotals.totalTargetAmount-tableData.expensesTotals.totalTargetAmount}}</b></th>
                            <th><b>{{tableData.profitTotals.totalEstimatedQuantity-tableData.expensesTotals.totalEstimatedQuantity}}</b></th>
                            <th><b>{{tableData.profitTotals.totalEstimatedPerAmount-tableData.expensesTotals.totalEstimatedPerAmount}}</b></th>
                            <th><b>{{tableData.profitTotals.totalEstimatedAmount-tableData.expensesTotals.totalEstimatedAmount}}</b></th>
                            <th><b>{{tableData.profitTotals.totalProposedQuantity-tableData.expensesTotals.totalProposedQuantity}}</b></th>
                            <th><b>{{tableData.profitTotals.totalProposedPerAmount-tableData.expensesTotals.totalProposedPerAmount}}</b></th>
                            <th><b>{{tableData.profitTotals.totalProposedAmount-tableData.expensesTotals.totalProposedAmount}}</b></th>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>

    </v-content>
</template>

<script>
    import axios from "axios";
    import {required} from "vuelidate/lib/validators";


    export default {

        name: "direct2",
        data() {
            return {
                submitStatus: "",
                yearList: [],
                searchFormData: {
                    year: ""
                },
                setYearValue: "",
                formData: {},
                tableData: [],
                search: false,
                callbackResponse: {
                    snackbar: false,
                    timeout: 6000,
                    message: ""
                },
                breadcrumbsItems: [
                    {
                        text: 'Upload',
                        disabled: false,
                        to: '/Upload/dashboard',
                        exact: true
                    },
                    {
                        text: 'खसी वोका तथा च्याङ्ग्रा कारोवारको विवरण',
                        disabled: true,
                    },
                ]

            }
        },
        // mixins: [excelExport],
        computed: {
            yearErrors() {
                const errors = [];
                if (!this.$v.searchFormData.year.$dirty) return errors;
                !this.$v.searchFormData.year.required &&
                errors.push("Year is required.");
                return errors;
            },
        },

        validations: {
            searchFormData: {
                year: {required},
            }
        },

        mounted() {
            this.getFormData()
        },

        methods: {
            setValueYear(data) {
                var year = this.yearList.filter(function (item) {
                    return item.value === data;
                });
                this.setYearValue = year[0].id;
            },


            getFormData() {
                axios.get("ReportSettings/GetReportYearList").then(response => {
                    this.yearList = response.data
                })
            },

            searchSubmit() {
                if (this.$v.$invalid) {
                    this.submitStatus = "ERROR";
                } else {
                    this.search = true
                    axios.get('Upload/GetMeatExpenses', {
                        params: {
                            year: this.searchFormData.year
                        }
                    }).then(response => {
                        this.tableData = response.data
                    })
                }
            },

            downloadData() {
                axios({
                    url: 'Upload/ExportExcelMeatExpenses',
                    method: 'POST',
                    responseType: 'blob',
                    params: {
                        year: this.searchFormData.year
                    }
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'ExportExcelMeatExpenses.xlsx'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            },
             downloadTotalData(tableID,filename) {

                var downloadLink;
                var dataType = 'application/vnd.ms-excel';
                var tableSelect = document.getElementById(tableID);
                var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

                // Specify file name
                filename = filename ? filename + '.xls' : 'excel_data.xls';

                // Create download link element
                downloadLink = document.createElement("a");

                document.body.appendChild(downloadLink);

                if (navigator.msSaveOrOpenBlob) {
                    var blob = new Blob(['\ufeff', tableHTML], {
                        type: dataType
                    });
                    navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // Create a link to the file
                    downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

                    // Setting the file name
                    downloadLink.download = filename;

                    //triggering the function
                    downloadLink.click();
                }
            
            },
            uploadData() {
                var form = new FormData();
                form.append(
                    "Excel",
                    this.formData.excel
                );

                form.append(
                    "year",
                    this.searchFormData.year
                );

                axios.post('Upload/ImportMeatExpenses', form).then(response => {
                    if (response.data.success) {
                        this.formData.excel = ""
                        this.callbackResponse.color = "success"
                        this.callbackResponse.snackbar = true
                        this.callbackResponse.message = "Data imported Successfullly."
                        this.searchSubmit()
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    table, td, th {
        border: 1px solid #ddd;
        text-align: left;
    }

    table {
        border-collapse: collapse;
        width: 100%;
    }

    th, td {
        padding: 15px;
    }

    .tbl-btn {
        padding: 1em;
        text-align: right;
    }

    .btn-download {
        text-align: left;
    }

    .total-header {
        background-color: #b2c4d2;
    }

    .total {
        background-color: #d2d2d2;
    }
</style>